import { Loading } from 'react-admin';
import Loadable from 'react-loadable';

const RouterList = Loadable({ loader: () => import('./routerList'), loading: Loading });

export default { 
  list: RouterList,
};